/*
 * @Description 组件  VideoPlay 视频播放
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<div :class="{'tree-item-box': true, 'mini-box': !showBoxFlag}">
		
		<div class="box-bar-item" @click="toggleBox" title="展开/收起 视频列表">
			<i v-if="showBoxFlag" class="iconfont el-icon-my_left2-copy"></i>
			<i v-else class="iconfont el-icon-my_right2"></i>
		</div>
		
		<div class="tree-group-title">
			<span class="tree-group-name" >视频列表</span>
			<el-button icon="el-icon-refresh" type="primary" size="mini" trigger="click" @click="searchVideo" title="刷新" style="font-size: 18px;padding: 5px 10px;position: relative;"><b v-if="newDataFlag" style="background-color: red;height: 10px;width: 10px;border-radius: 50%; position: absolute;top: -5px;right: -5px;"></b></el-button>
		</div>
		
		<div class="tree-group-item">
			
			<!-- list 内容 start -->
			<ul class="list-items-rows">
				<li v-if="!$checkEmpty(item)" :class="{'list-items-row cursor-pointer text-over': true, 'list-row-disabled': (item.isOpen != 1 || !(item.diskIp ? item.pingDiskIp : true) || !item.pingCameraIp || !item.realAddr), 'on': (dataKeys.indexOf(item.number) != -1)}" v-for="(item, index) in videoInfos" :key="[item.number, index].join('_')" :title="extractRowItemTitle(index, videoInfos)" @click="handleItemsRow(item, index)"><span class="sort-item-index">{{index + 1}}</span>{{extractRowItem(index, videoInfos)}}</li>
			</ul>
			<!-- list 内容 end -->
			
		</div>
	</div>
</template>

/* JS */
<script>
	// API 视频接口
    import ApiVideo from '@/request/api-video';
	// 组件 播放视频
	import SubVideo from '@/components/SubVideo/SubVideo';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "videoPlayList",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	// 组件 播放视频
			SubVideo,
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
		props: {
			/**
			 * @Des 展示box
			 * @Auth
			 * @Date
			 */
			showBoxFlag: {
				type: Boolean,
				default: function (){
					return true
				}
			},// showBoxFlag
			
			// 选中 下标
			dataKeys: {
				type: Array,
				default: function (){
					return [];
				}
			},// dataKeys
			
			// 展示数据
			videoInfos: {
				type: Array,
				default: function (){
					return [];
				}
			},// videoInfos
		},// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				// 数据有更新
				newDataFlag: false,
				
				/**
				 * @Des 查询条件属性
				 * @Auth
				 * @Date
				 */
				filters: {
					readModes: [{
						id: 1,
						name: '硬盘录像机'
					},{
						id: 2,
						name: '摄像头'
					}],
					brands: [{
						id: 1,
						name: '海康'
					},{
						id: 2,
						name: '宇视'
					},{
						id: 3,
						name: '大华'
					}],
					subtypes: [{
						id: 1,
						name: '主码流'
					},{
						id: 2,
						name: '子码流'
					}],
					codecs: [{
						id: 1,
						name: 'H.264'
					},{
						id: 2,
						name: 'H.265'
					}],
				},// filters
				
			}// return
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			// 开启订阅消息
			this.startSubscribes();
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			// 取消订阅消息
			this.endSubscribes();
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			/**
			 * @Des mini max box
			 * @Auth
			 * @Date
			 */
			toggleBox() {
				this.$emit('toggleBox', !this.showBoxFlag);
			},
			
			//========================== 订阅消息 start ==========================
			/**
			 * @Des 开启订阅消息
			 * @Auth
			 * @Date
			 */
			startSubscribes() {
				// 订阅消息 视频配置
				this.sub_videoChange = this.$pubsub.subscribe('VideoChange', (name, data) => {
					// 数据更新
					this.newDataFlag = true;
				});
			},
			/**
			 * @Des 取消订阅消息
			 * @Auth
			 * @Date
			 */
			endSubscribes() {
				//取消订阅 视频配置
				this.$pubsub.unsubscribe(this.sub_videoChange);
			},
			
			//========================== 订阅消息 end ==========================
			/**
			 * @Des 刷新列表
			 * @Auth
			 * @Date
			 */
			searchVideo() {
				// 数据有更新
				this.newDataFlag = false;
				this.$emit('searchVideo');
			},
			/**
			 * @Des 点击列表 row
			 * @Auth
			 * @Date
			 */
			handleItemsRow(row, index) {
				this.$emit('handleItemsRow', row, index);
			},// handleItemsRow
			
			/**
			 * @Des 检索row 数据
			 * @Auth
			 * @Date
			 */
			checkRowItem(index, rows=[]) {
				// 空值 中止
				if (this.$checkEmpty(index)) return false;
				
				return !this.$checkEmpty(rows[index]) && !this.$checkEmpty(rows[index].diskChannelName);
			},// checkRowItem
			
			/**
			 * @Des 提取row 数据
			 * @Auth
			 * @Date
			 */
			extractRowItem(index, rows=[]) {
				// 空值 中止
				if (this.$checkEmpty(index)) return '';
				// 空值 中止
				if (this.$checkEmpty(rows[index])) return '';
				
				// 名称
				let diskChannelName = !this.$checkEmpty(rows[index].diskChannelName) ? rows[index].diskChannelName : '';
				// 编号
				let _number = !this.$checkEmpty(rows[index].number) ? rows[index].number : '';
				return [diskChannelName, (!this.$checkEmpty(_number) ? ('（'+ _number +'）') : '')].join('');
			},// extractRowItem
			/**
			 * @Des 提取row 数据 title
			 * @Auth
			 * @Date
			 */
			extractRowItemTitle(index, rows=[]) {
				// 空值 中止
				if (this.$checkEmpty(index)) return '';
				let row = Object.assign({}, rows[index]);
				// 空值 中止
				if (this.$checkEmpty(row)) return '';
				
				let list = [];
				
				// 视频名称
				list.push(['视频名称', (row.diskChannelName ? row.diskChannelName : '----')].join('：'));
				
				// 视频编号
				list.push(['视频编号', (row.number ? row.number : '----')].join('：'));
				
				// IP
				list.push(['IP', (row.diskIp ? row.diskIp : row.cameraIp ? row.cameraIp : '----')].join('：'));
				
				// 码流类型
				let subtypeName = this.matchRowsByKey(this.filters.subtypes, 'id', row.subtype).name;
				list.push(['码流类型', (!this.$checkEmpty(subtypeName) ? subtypeName : '----')].join('：'));
				
				// 编码格式
				let codecName = this.matchRowsByKey(this.filters.codecs, 'id', row.codec).name;
				list.push(['编码格式', (!this.$checkEmpty(codecName) ? codecName : '----')].join('：'));
				
				// 读取类型
				let readModeName = this.matchRowsByKey(this.filters.readModes, 'id', row.readMode).name;
				list.push(['读取类型', (!this.$checkEmpty(readModeName) ? readModeName : '----')].join('：'));
				
				// 通道号
				list.push(['通道号', (row.diskChannelNo ? row.diskChannelNo : '----')].join('：'));
				
				// 账号
				list.push(['账号', (row.diskAccount ? row.diskAccount : row.cameraAccount ? row.cameraAccount : '----')].join('：'));
				
				// 是否启用
				list.push(['是否启用', (row.isOpen == 1 ? '已启用' : '未启用')].join('：'));
				
				// 摄像头厂家
				let brandName = this.matchRowsByKey(this.filters.brands, 'id', row.brand).name;
				list.push(['摄像头厂家', (!this.$checkEmpty(brandName) ? brandName : '----')].join('：'));
				
				return Object.assign([], list).join('\n');
			},// extractRowItemTitle
			
			/**
			 * @Des 数据匹配
			 * @Auth
			 * @Date
			 */
			matchRowsByKey(rows, key, val){
				let obj = {};
				let keys = Object.keys(rows);
				keys.forEach((_key, index) => {
					let row = Object.assign({}, rows[_key]);
					if (row[key] == val) {
						obj = Object.assign({}, row);
					}
				});
				return obj;
			},// matchRowsByKey
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_pages/Video/videoPlayList.vue